
import DetectorInterface from "../DetectorInterface";
import Detector from '../Detector';

export default class Phone extends Detector implements DetectorInterface {

    public match(value: string): boolean {

        // Match +15126706483
        return /^\+[0-9]{8,20}$/.test(value);
    }
}
